/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hamburger_medium'
export default icon
